'use client';

import { useCampaignCategory, withoutCampaignCategory } from '@/components/features/campaigns';
import { useSidebarGroupCategories } from '@/hooks/useSideBarGroupCategories';
import { usePathname } from '@/i18n/routing';
import CategoryItem from './CategoryItem';
import NavigationItem from './NavigationItem';
import OtherCategoriesAccordion from './OtherCategoriesAccordion';

interface Props {
  categoryId: string;
  isMenuMinify: boolean;
  handleCloseSideBar: () => void;
}

/** The sidebar's categories block: the Campaign spot, then the category groups around Favorites. */
const SidebarCategories = ({ categoryId, isMenuMinify, handleCloseSideBar }: Props) => {
  const pathname = usePathname();
  const campaignCategory = useCampaignCategory();
  const groups = useSidebarGroupCategories();

  const beforeFavoritesCategories = withoutCampaignCategory(groups.beforeFavoritesCategories, campaignCategory);
  const afterFavoritesCategories = withoutCampaignCategory(groups.afterFavoritesCategories, campaignCategory);
  const otherCategories = withoutCampaignCategory(groups.otherCategories, campaignCategory);

  return (
    <div className="flex flex-col gap-1 relative md:gap-1 3xl:px-1">
      {campaignCategory && (
        <CategoryItem
          category={campaignCategory.category}
          icon={campaignCategory.icon}
          label={campaignCategory.sidebarLabel}
          categoryId={categoryId}
          handleCloseSideBar={handleCloseSideBar}
          isMenuMinify={isMenuMinify}
        />
      )}
      {beforeFavoritesCategories.map(category => (
        <CategoryItem
          key={category.id}
          category={category}
          categoryId={categoryId}
          handleCloseSideBar={handleCloseSideBar}
          isMenuMinify={isMenuMinify}
        />
      ))}
      <NavigationItem
        label="Favorites"
        icon="favorites"
        href="/category/favorites-games"
        variant="account"
        isActive={pathname === '/category/favorites-games'}
        handleCloseSideBar={handleCloseSideBar}
      />

      {afterFavoritesCategories.map(category => (
        <CategoryItem
          key={category.id}
          category={category}
          categoryId={categoryId}
          handleCloseSideBar={handleCloseSideBar}
          isMenuMinify={isMenuMinify}
        />
      ))}
      {otherCategories.length > 0 && (
        <OtherCategoriesAccordion
          categoryId={categoryId}
          handleCloseSideBar={handleCloseSideBar}
          isMenuMinify={isMenuMinify}
          otherCategories={otherCategories}
        />
      )}
    </div>
  );
};

export default SidebarCategories;
